export const signInTheme = {
  copyIconColor: 'palette.tertiary.40',
  error: 'palette.error.60',
  hintMessage: {
    text: 'palette.tertiary.95',
  },
  title: 'palette.tertiary.95',
};
